import s from "./style.module.css";
export interface Input extends Marko.HTML.Button {
    size?: "medium" | "large";
}

<const/{ content, class: inputClass, size = "large", ...htmlInput }=input>

<button ...htmlInput class=[s.button, inputClass] data-size=size>
    <${input.content}/>
</button>
